import { z } from "zod";

const INTERNATIONAL_PHONE_REGEX = /^\+[1-9]\d{1,14}$/;

export const voyadoContactSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().min(1, "Email is required").email("Invalid email address"),
  company: z.string().optional(),
  companyTitle: z.string().optional(),
  countryCode: z.string().length(2, "Country is required"),
  instagramHandle: z.string().optional(),
  mobilePhone: z.union([
    z.literal(""),
    z
      .string()
      .regex(
        INTERNATIONAL_PHONE_REGEX,
        "Use international phone number format (e.g. +1234567890)",
      ),
  ]),
});

export type VoyadoContact = z.infer<typeof voyadoContactSchema>;
